var _rect, _rect2, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPrescriptionDefaultImage = function SvgPrescriptionDefaultImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 90,
    width: 90
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "#cbcbcb",
    rx: 0,
    ry: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 49.9,
    height: 36.4,
    x: 20.1,
    y: 26.8,
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "square",
    strokeMiterlimit: 30.3,
    strokeWidth: 4.9,
    rx: 3.4,
    ry: 3.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M55.3 34.4l-6.8 8.9-3.3-3.8-10 12.1-3.5-3.2-6.6 9.2H65v-7.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.2,
    cy: 38.1,
    r: 5.1,
    fill: "#a0a0a0"
  })));
};
export default SvgPrescriptionDefaultImage;